<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <div class="tip">银行卡信息用于线下提现使用</div>
        <div class="order-detail-box">
          <div class="label-val">
            <div class="label-1">户名</div>
            <div class="value-1">{{ detail.cardholder }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">开户行</div>
            <div class="value-1">{{ detail.bankName }}</div>
          </div>
          <div class="label-val">
            <div class="label-1">银行卡号</div>
            <div class="value-1">
              <custom-copy :txt="detail.bankCardNo"></custom-copy>
            </div>
          </div>
        </div>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import UploadFiles2 from "@/components/UploadFiles4.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomCopy from "@/components/CustomCopy.vue";
import {
  bankInfo,
  detailInfo,
} from "@/views/FinancialManagement/WalletManagement/api";
export default {
  name: "AddOrEdit",
  components: {
    CustomCopy,
    CustomTable,
    UploadFiles2,
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      imageUrl: require("@/assets/imgs/bg.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "银行卡信息",
        closeOnClickModal: false,
        confirmFn: "",
        beforeClose: (v) => {
          this.detail = {};
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      detail: {},
    };
  },
  mounted() {},
  methods: {
    init(row) {
      this.getDetailInfo(row.userId);
      this.dialogObj.show = true;
    },
    getDetailInfo(userId) {
      bankInfo(userId).then((res) => {
        if (res.code === 200) {
          this.detail = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.12rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .common-image-box {
    margin-bottom: 0;
    margin-top: 0.04rem;
  }
  .invice-info {
    line-height: 0.24rem;
    margin-bottom: 0.2rem;
  }
  .radio-box {
    display: flex;
    align-items: center;
    span {
      font-size: 0.12rem;
      color: #8c8c8c;
    }
  }
  .tip {
    padding: 0rem 0 0.2rem;
  }
}
</style>
